import { ReactNode } from 'react';

import { Heading } from '@/components/ui/heading';
import { Text } from '@/components/ui/text';
import { View } from '@/components/ui/view';

export function PageWebBanner({
  header,
  subtext,
}: {
  header: string;
  subtext: ReactNode | string;
}) {
  return (
    <View className="flex w-full justify-center bg-primary-500 p-8">
      <View>
        <Heading className="mb-2 text-center font-normal text-white" size="h1-2xl">
          {header}
        </Heading>
        {typeof subtext === 'string' ? (
          <Text className="text-center text-white">{subtext}</Text>
        ) : (
          subtext
        )}
      </View>
    </View>
  );
}
